module.exports = __webpack_public_path__ + "static/media/right.6a74aa20.svg";